import { Spin } from "antd";

import React from "react";

function Spinner({ message='Loading' }) {
  return (
    <Spin
      tip={ `${message}...`}
      size="small"
      className="my-5 text-danger "
      style={{ fontSize: "1.2rem" }}
    />
  );
}

export default Spinner;

// <div className="spinner-border text-danger" role="status">
//   <span className="visually-hidden">Loading...</span>
// </div
